<template>
  <div>
    <el-dialog class="main_dialog" title="以图搜款" :visible.sync="dialogTableVisible" width="60%">
      <div class="search_box">
        <el-upload
          class="upload_box"
          :style="{width: imageUrl ? '22%' : '100%', height: imageUrl ? 'auto' : '300px'}"
          action
          :show-file-list="false"
          :http-request="handleUploadImage">
          <img v-if="imageUrl" :src="imageUrl" class="upload_img">
          <div v-else>
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div>请先上传需要搜索的图片</div>
          </div>
        </el-upload>
        <div class="list_box" v-loading="searchLoading">
          <div v-for="item in searchList" class="list_item">
            <div class="list_img"><img :src="item.url" alt=""></div>
            <div class="list_simi">相似度：{{ item.similarity }}</div>
            <div class="list_title">{{ item.image_title || item.name }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { materialSearchByImage } from '@/api/material'
export default {
  name: "ImageSearch",
  data () {
    return {
      dialogTableVisible: false,
      imageUrl: '',
      searchLoading: false,
      searchList: []
    }
  },
  watch: {
    dialogTableVisible(newVal) {
      if (newVal) {
        this.searchList = [];
        this.imageUrl = '';
      }
    },
  },
  methods:{
    handleUploadImage(param) {
      this.searchLoading = true
      // this.imageUrl = this.readImage(param.file)
      let self = this
      let reader = new FileReader()
      reader.onload = (e) => {
        self.imageUrl = e.target.result
      }
      reader.readAsDataURL(param.file)
      
      let formData = new FormData()
      formData.append('image', param.file)
      materialSearchByImage(formData).then(res => {
        this.searchList = res.data.list
        this.searchLoading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search_box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .upload_box {
    flex-shrink: 0;
    border: 1px dashed #BFBFBF;
    border-radius: 8px;
    text-align: center;
    /deep/ .el-upload {
      width: 100%;
      height: 100%;
      padding: 32px 0;
      font-size: 13px;
      color: #898989;
      display: flex;
      align-items: center;
      justify-content: center;
      .upload_img {
        width: 100%;
        object-fit: cover;
      }
      .el-icon-plus {
        font-size: 28px;
        margin-bottom: 12px;
      }
    }
  }
  .list_box {
    display: flex;
    flex-wrap: wrap;
    margin-left: 24px;
    flex: 1;
    gap: 1.3%;
    .list_item {
      width: 24%;
      border: 1px solid #ededed;
      margin-bottom: 16px;
      position: relative;
      .list_img {
        width: 100%;
        position: relative;
        &::after {
          padding-top: 100%;
          content: '';
          display: block;
        }
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          vertical-align: middle;
        }
      }
      .list_simi {
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(84,84,84,0.7);
        color: #fff;
        padding: 4px 8px;
        font-size: 12px;
        border-bottom-right-radius: 8px;
      }
      .list_title {
        padding: 8px 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>